import React, { useEffect, useState } from "react";
import { Popover } from "@mui/material";
import { Button } from "@mui/joy";
import styles from "./phoneinbound.module.css";

//큐 칩 클릭 → 담당 모드 팝오버 (본사 담당자 / 지점 직접 수신). 저장은 부모의 onSave(queue, mode)
const ManagerModePopover : React.FC<any> = (props) => {

    const q = props.queue;
    const [mode, setMode] = useState<string>("hq");
    const [saving, setSaving] = useState<boolean>(false);

    useEffect(() => {
        if (props.anchorEl && q) {
            setMode(q.managerMode || "hq");
            setSaving(false);
        }
    }, [props.anchorEl, q]);

    if (!q) {
        return null;
    }

    const branchPhones : any[] = props.branchPhones || [];
    const branchLabel = branchPhones.length > 0
        ? `${branchPhones.map((r : any) => `${r.name}(${r.extension})`).join(", ")}이 먼저 받음 · 본사는 15초 뒤 합류`
        : "이 지점에 등록된 지점 폰이 없습니다 · 담당 벨 없이 바로 전체 벨";

    const save = async () => {
        if (mode === (q.managerMode || "hq")) {
            props.onClose();
            return;
        }
        setSaving(true);
        const okResult = await props.onSave(q.queue, mode);
        setSaving(false);
        if (okResult) {
            props.onClose();
        }
    };

    return (
        <Popover
            open={!!props.anchorEl}
            anchorEl={props.anchorEl}
            onClose={props.onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            PaperProps={{ className: styles.popoverPaper }}
        >
            <div className={styles.popoverTitle}>{q.name} ({q.queue}) 담당 설정</div>
            {
                q.pairQueueExists ?
                    <>
                        <div className={styles.popoverSub}>담당자 큐: {q.pairQueue} {q.pairQueueName} <span className={styles.popoverOk}>✓ 연결됨</span></div>
                        <div className={`${styles.radioCard} ${mode === "hq" ? styles.radioCardActive : ""}`} onClick={() => setMode("hq")}>
                            <span className={`${styles.radioDot} ${mode === "hq" ? styles.radioDotActive : ""}`} />
                            <div>
                                <div className={styles.radioTitle}>본사 담당자</div>
                                <div className={styles.radioDesc}>아래 [담당] 지정된 본사 직원이 먼저 받음 · 현재 {props.managerCount || 0}명</div>
                            </div>
                        </div>
                        <div className={`${styles.radioCard} ${mode === "branch" ? styles.radioCardActive : ""}`} onClick={() => setMode("branch")}>
                            <span className={`${styles.radioDot} ${mode === "branch" ? styles.radioDotActive : ""}`} />
                            <div>
                                <div className={styles.radioTitle}>지점 직접 수신</div>
                                <div className={styles.radioDesc}>{branchLabel}</div>
                            </div>
                        </div>
                        <div className={styles.popoverButtons}>
                            {
                                props.canEditQueues ?
                                    <Button size="sm" variant="plain" color="danger" onClick={() => { props.onClose(); props.onRemoveQueue(q); }} disabled={saving} style={{ marginRight: "auto" }}>큐 제거</Button>
                                    : null
                            }
                            <Button size="sm" variant="outlined" color="neutral" onClick={props.onClose} disabled={saving}>닫기</Button>
                            <Button size="sm" variant="solid" onClick={save} loading={saving} disabled={mode === (q.managerMode || "hq")}>저장</Button>
                        </div>
                    </>
                    :
                    <>
                        <div className={styles.popoverError}>
                            ⚠ 담당자 큐({q.pairQueue} {q.pairQueueName})가 교환기에 없습니다.<br />
                            FreePBX에서 큐를 만든 뒤 동기화하면 담당자 지정이 가능해집니다.
                        </div>
                        <div className={styles.popoverButtons}>
                            {
                                props.canEditQueues ?
                                    <Button size="sm" variant="plain" color="danger" onClick={() => { props.onClose(); props.onRemoveQueue(q); }} style={{ marginRight: "auto" }}>큐 제거</Button>
                                    : null
                            }
                            <Button size="sm" variant="outlined" color="neutral" onClick={props.onClose}>닫기</Button>
                        </div>
                    </>
            }
        </Popover>
    );
};

export default ManagerModePopover;
